<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg4 xl3>
            <v-card class="elevation-1 pa-3">
              <v-card-text>
                <div class="layout column align-center">
                  <br>
                  <img src="/static/logo.png" alt="Logo" width="240">
                  <h2 class="flex my-4 primary--text">Nhập OTP</h2>
                  <p style="text-align: center;">
                    Một mã OTP vừa được gửi đến {{email ? 'email' : 'số điện thoại'}}
                    <b>{{email || phone}}</b>, vui lòng kiểm tra và nhập OTP vào bên dưới
                  </p>
                </div>
                <v-form v-model="form.valid" ref="form">
                  <v-text-field
                    append-icon="phonelink_lock"
                    name="login"
                    label="Mã OTP"
                    type="text"
                    v-model="form.otp"
                    :rules="[validate.required, validate.numeric]"
                    @keydown.enter.prevent="submit()"
                  ></v-text-field>
                  <br>
                  <v-btn
                    block
                    round
                    color="black"
                    class="login-btn"
                    :loading="isLoading"
                    @click="submit()"
                  >Tiếp theo</v-btn>
                  <br>
                  <v-layout align-center justify-center>
                    <v-btn flat small @click="goBackLogin()">Quay lại đăng nhập</v-btn>
                    <v-btn flat small @click="resendOtp()" :loading="loadingResend">Gửi lại mã OTP</v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import validate from '@/utils/validate';
import { mapActions, mapMutations } from 'vuex';

export default {
  data: () => ({
    validate: validate,
    isLoading: false,
    form: {
      valid: false,
      otp: ''
    },
    loadingResend: false
  }),
  computed: {
    email () {
      return this.$store.state.user.forgotPasswordEmail;
    },
    phone () {
      return this.$store.state.user.forgotPasswordPhone;
    }
  },
  methods: {
    ...mapActions(['checkOtp', 'requestOtp']),
    ...mapMutations(['SET_FORGOT_PASSWORD_OTP']),
    submit () {
      if (this.form.valid) {
        if (this.email) this.form.email = this.email;
        if (this.phone) this.form.phone = this.phone;
        this.checkOtp(this.form)
          .then(res => {
            this.isLoading = false;
            this.SET_FORGOT_PASSWORD_OTP(this.form.otp);
            window.location.href = `#/confirmpassword`;
          })
          .catch(err => {
            this.isLoading = false;
            let message = 'Có lỗi xảy ra, vui lòng thử lại';
            if (err.code === 'ERR_OTP_NOT_MATCH') {
              message = 'Mã OTP không đúng, vui lòng thử lại';
            }
            window.getApp.showMessage(message, 'error');
          });
      } else {
        this.$refs.form.validate();
      }
    },

    resendOtp () {
      let data = {
        email: this.email,
        phone: this.phone
      };
      this.loadingResend = true;
      this.requestOtp(data)
        .then(res => {
          this.loadingResend = false;
          
          window.getApp.showMessage('Gửi mã OTP thành công. Vui lòng kiểm tra lại!', 'success');
        })
        .catch(err => {
          this.loadingResend = false;
          let message = 'Có lỗi xảy ra, vui lòng thử lại';
          if (err.code === 'ERR_EMAIL_NOT_EXIST') {
            message = 'Email không tồn tại trong hệ thống';
          }
          if (err.code === 'ERR_PHONE_NOT_EXIST') {
            message = 'Số điện thoại không tồn tại trong hệ thống';
          }
          window.getApp.showMessage(message, 'error');
        });
    },

    goBackLogin () {
      this.$refs.form.reset();
      this.$router.push('/login');
    }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.login-btn {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/forgotpassword/otp.vue